import { Injectable } from '@angular/core';
import {
    ClearNotificationBodyAction,
    NotificationBodyArrivedAction,
    NotificationTestAction
} from './notification.actions';
import { Store } from '@ngrx/store';
import { firstValueFrom, Observable } from 'rxjs';
import { NotificationState } from './notification.state';
import { filter, map } from 'rxjs/operators';
import { AppState } from '../app.state';

@Injectable()
export class NotificationStateDispatcher {
    constructor(
        private store: Store < AppState > ,
    ) {}

    /** Returns an Observable of notification state with non-null notificationData */
    public getNotificationState(): Observable < NotificationState > {
        return this.store.select((state: AppState) => state.notification)
        .pipe(filter(notificationState => notificationState.notificationData != null));
    }

    public getToken(): Promise < string | undefined > {
        return firstValueFrom(this.getNotificationState().pipe(
            filter(state => state !== null),
            map(notificationState => notificationState.notificationData),
            filter(data => data !== null),
            map(notificationData => notificationData ? notificationData.token : undefined),
            filter(token => token !== null),
        ));
    }

    public processNotificationBody(body): void {
        this.store.dispatch(new NotificationBodyArrivedAction({ body: body }));
    }

    public clearNotificationBody(): void {
        this.store.dispatch(new ClearNotificationBodyAction());
    }

    public testNotification(): void {
        this.getToken().then(token => {
            if (token) {
                this.store.dispatch(new NotificationTestAction(token));
            } else {
                console.error(`Failed to run test notification. Token is undefined`);
            }
        });
    }
}
